module.exports = __webpack_public_path__ + "assets/bell-small-active-hover.cf511a83.svg";